import { createRestClient, RestSchemas } from '@/contexts/QueryProvider'
import { useGetSearchParam } from '@/hooks'
import { Skeleton } from '@/components/shadcn/skeleton'
import { IconBoxOutline, IconCopyOutline, IconDictionaryOutline, IconHelpQuestionOutline } from '@/components/icons'

const IconMap = {
  'data-templates': IconCopyOutline,
  'data-assets': IconBoxOutline,
  glossary: IconDictionaryOutline,
  faq: IconHelpQuestionOutline,
}

// type MessagesSupportMenuSupportMenuItem = RestSchemas['Messages.SupportMenu.SupportMenuItem']

const _supportPanelViews = ['small', 'expanded'] as const
const _supportPanelTypes = ['data-templates', 'data-assets', 'glossary', 'faq'] as const
export type SupportPanelSize = (typeof _supportPanelViews)[number]
export type SupportPanelType = (typeof _supportPanelTypes)[number]
export type SupportPanelView = { key: SupportPanelType; size: SupportPanelSize }

export function AppSupportMenu({
  setSupportPanelView,
}: {
  setSupportPanelView: React.Dispatch<React.SetStateAction<SupportPanelView | undefined>>
}) {
  const projectId = useGetSearchParam<number>('projectId')
  const appId = useGetSearchParam<number>('appId')
  const { getUiApiGetSupportMenu } = createRestClient()

  const { data: supportMenu } = getUiApiGetSupportMenu.useSuspenseQuery(
    {
      query: { applicationId: appId, projectId: projectId },
    },
    {
      staleTime: 24 * 60 * 60 * 1000, // 24 hours
    }
  )

  console.log('data: supportMenu', supportMenu)

  return (
    <div className="w-full items-start rounded-lg bg-grey-lighterer px-3 py-2">
      {supportMenu.map((item) => {
        const Icon = item.key ? IconMap[item.key as keyof typeof IconMap] : null
        return (
          <button
            className="inline-flex cursor-pointer items-center gap-x-2 whitespace-nowrap text-grey-darkest hover:text-primary"
            key={item.key}
            // onClick={() => setSupportPanelView(item.key ?? '')}
            onClick={() => setSupportPanelView({ key: item.key as SupportPanelType, size: 'small' })}
          >
            {Icon && <Icon className="size-4" />}
            {item.label}
          </button>
        )
      })}
      {/* <button onClick={() => setSupportPanelView('small')}>FAQ</button>
      <button onClick={() => setSupportPanelView('small')}>Data Asstes</button>
      <button onClick={() => setSupportPanelView('small')}>Data Templates</button> */}
    </div>
  )
}

export function AppSupportMenuLoading() {
  return (
    <div className="w-full items-start rounded-lg bg-grey-lighterer px-3 py-2">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-24" />
    </div>
  )
}
